// extracted by mini-css-extract-plugin
var _1 = "CustomBtnStyle-module__btn___Bw3mw";
var _2 = "CustomBtnStyle-module__submit___Hugld";
export { _1 as "btn", _2 as "submit" }
